export default "__VITE_ASSET__Bbw$UAZL__"